import Alert from '@preqin/ui-components/cjs/core/Alerts/Alert';

import { AlertPriority, RedirectProps } from './types';

//This component implemented for temporarily time until GP Team shutdowns Transaction Intelligence product from PowerBI Dashboard
export const TransactionIntelligenceRedirectBanner = ({ handleOnClose }: RedirectProps) => {
  return (
    <Alert
      message="Try the new and improved Transaction Intelligence"
      secondaryMessage="We’ve redesigned Transaction Intelligence to be faster, simpler, and easier to use. It’s now live at a new URL. If you're still using the old version, switch over for a better workflow."
      type="feedback"
      priority={AlertPriority.warning}
      size="medium"
      closeEnabled
      handleOnClose={handleOnClose}
      actions={[
        {
          label: 'Go to new Transaction Intelligence',
          onClickFunction: () => (window.location.href = 'https://pro.preqin.com/transactionIntelligence'),
          text: 'Go to new Transaction Intelligence',
          handleOnClick: () => (window.location.href = 'https://pro.preqin.com/transactionIntelligence'),
        },
      ]}
    />
  );
};
